import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      const from = location.state?.from || "/";
      navigate(from);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto my-16">
      <div className="overline text-[#C5A059] mb-3 text-center">Enter the sanctuary</div>
      <h1 className="font-serif text-4xl text-center text-[#FDFBF7] tracking-tight mb-2">Welcome back</h1>
      <p className="text-center text-[#A1A4AB] mb-8">Sign in to continue listening.</p>
      <form onSubmit={submit} className="space-y-4 card-surface p-8" data-testid="login-form">
        <div>
          <label className="text-sm text-[#A1A4AB] mb-2 block">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-lux" data-testid="login-email-input" placeholder="you@example.com" />
        </div>
        <div>
          <label className="text-sm text-[#A1A4AB] mb-2 block">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-lux" data-testid="login-password-input" placeholder="••••••••" />
          <div className="text-right mt-1.5">
            <Link to="/forgot-password" className="text-xs text-[#C5A059] hover:text-[#DCC286]" data-testid="login-forgot-password-link">
              Forgot password?
            </Link>
          </div>
        </div>
        {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit-btn">
          {loading ? "Signing in..." : "Sign in"}
        </button>
        <div className="text-center text-sm text-[#A1A4AB] pt-2">
          New here?{" "}
          <Link to="/register" className="text-[#C5A059] hover:text-[#DCC286]" data-testid="login-to-register-link">Create an account</Link>
        </div>
      </form>
    </div>
  );
}
